import React, { Component, PropTypes } from 'react';
import * as B from 'react-bootstrap';
import moment from 'moment';
import FileInput from 'components/lib/FileInput';
import Errorable from 'components/lib/Errorable';
import Loadable from 'components/lib/Loadable';
import '../styles/fileUpload.scss';

@Errorable()
class ChatFileUpload extends Component {
  static propTypes = {
    token: PropTypes.string.isRequired,
    embedded: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    files: PropTypes.arrayOf(PropTypes.object),
    progress: PropTypes.arrayOf(PropTypes.any),
    buttonLabel: PropTypes.string.isRequired,
    multiple: PropTypes.bool.isRequired,
    caseNumber: PropTypes.number.isRequired,
    allowedFileExtensions: PropTypes.arrayOf(PropTypes.string),
    onMinimize: PropTypes.func.isRequired,
    onSelectFiles: PropTypes.func.isRequired,
    onStartUpload: PropTypes.func.isRequired,
  };
  upload() {
    this.props.onStartUpload(this.props.modalProps.onSendFilesToAgents, this.props.caseNumber, this.props.files, this.props.token, this.props.embedded);
  }
  render() {
    let { props } = this;
    return (
      <B.Modal {...props.modalProps}>
        <B.Modal.Header closeButton={!!props.modalProps.onHide}>
          <B.Modal.Title className="chat-fileupload-title">{props.title}</B.Modal.Title>
        <B.Modal.Body>
          <FileInput label={props.buttonLabel} multiple={props.multiple} files={props.files}
            onChange={props.onSelectFiles} progress={props.progress} allowedFileExtensions={props.allowedFileExtensions}
          />
          {
            props.progress ? (
              <p>Puede cerrar esta ventana mientras los archivos se suben</p>
            ) : undefined
          }
          { this.error() }
        </B.Modal.Body>
        </B.Modal.Header>
        <B.Modal.Footer>
          {
            props.files.length > 0 && props.progress === undefined ? (
              <B.Button bsStyle="success" onClick={this.upload.bind(this)}>Subir</B.Button>
            ) : undefined
          }
          <B.Button className="chat-fileupload-footer-btn"
            onClick={props.onMinimize}>Cerrar</B.Button>
        </B.Modal.Footer>
      </B.Modal>
    );
  }
}

export default ChatFileUpload;



// WEBPACK FOOTER //
// ./components/chat/fileUpload/index.js